const SET_ERROR = 'errors/SET_ERROR';
const REMOVE_ERROR = 'errors/REMOVE_ERROR';
const CLEAN_ERRORS = 'errors/CLEAN_ERRORS';

export default {
  SET_ERROR,
  REMOVE_ERROR,
  CLEAN_ERRORS,
};
